import { useMemo } from 'react';
import { Box, Button, Card, Column, Divider, Row, Typography } from 'seagull';
import { ArrowRight, Bulb24 } from 'seagull/icons';
import RecipientDetails from "../../../../components/RecipientDetails/RecipientDetails";
import { relationshipModel } from "../../../../models";
import { fromDateStampObject } from "../../../../models/time";
import { formatLongMonthUSDate } from "../../../../utils";
import { getLimitedTimeDiscountOfferCalloutText } from "../../WelcomeStep/welcomeStepUtils";
import { GetCoverPageTID } from "./CoverPage";
import styles from "./CoverPageDesktop.module.scss";
import { CoverPageHeader } from "./CoverPageHeader/CoverPageHeader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const CoverPageDesktop = _ref => {
  var _relationship$signato;
  let {
    testId,
    relationship,
    onGetStarted,
    isPreview
  } = _ref;
  const {
    CoverPageTestIds
  } = useMemo(() => GetCoverPageTID(testId), [testId]);
  const vendorName = relationship.vendor.name;
  const clientName = relationship.customer.name;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: relationship.vendor
  });
  const isDisabled = Boolean(relationship.isSample || isPreview);
  const expirationDate = relationship.expirationDate ? fromDateStampObject(relationship.expirationDate) : null;
  const discountCalloutText = getLimitedTimeDiscountOfferCalloutText(relationship);
  const hasExpirationInfo = expirationDate || discountCalloutText;
  return /*#__PURE__*/_jsx(Card, {
    padding: "m",
    className: styles.card,
    "data-testid": CoverPageTestIds.Root(),
    children: /*#__PURE__*/_jsxs(Column, {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(CoverPageHeader, {
        testId: testId,
        isDisabled: isDisabled,
        relationship: relationship
      }), /*#__PURE__*/_jsxs(Column, {
        className: styles.content,
        gap: 32,
        children: [vendorLogoUrl && /*#__PURE__*/_jsx("img", {
          "data-testid": CoverPageTestIds.VendorLogo(),
          src: vendorLogoUrl,
          alt: vendorName,
          className: styles.vendorLogo
        }), /*#__PURE__*/_jsxs(Column, {
          children: [/*#__PURE__*/_jsxs(Column, {
            gap: 8,
            children: [/*#__PURE__*/_jsx(Typography, {
              "data-testid": CoverPageTestIds.ProposalTitle(),
              variant: "h1",
              weight: "bold",
              fontFamily: "hero",
              children: "Proposal for review"
            }), /*#__PURE__*/_jsxs(Typography, {
              "data-testid": CoverPageTestIds.ProposalPreparedFor(),
              variant: "h4",
              weight: "normal",
              fontFamily: "hero",
              children: ["Prepared for ", clientName]
            }), /*#__PURE__*/_jsxs(Typography, {
              "data-testid": CoverPageTestIds.PropsalDescription(),
              children: [vendorName, " has sent you this proposal and is requesting that you sign and accept it."]
            })]
          }), /*#__PURE__*/_jsx(Divider, {
            margin: 16
          }), hasExpirationInfo && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(Row, {
              gap: 8,
              alignItems: "start",
              children: [/*#__PURE__*/_jsx(Box, {
                className: styles.primaryIcon,
                children: /*#__PURE__*/_jsx(Bulb24, {})
              }), /*#__PURE__*/_jsxs(Column, {
                gap: 4,
                children: [expirationDate && /*#__PURE__*/_jsxs(Typography, {
                  "data-testid": CoverPageTestIds.ProposalExpirationDate(),
                  children: ["Please note that this proposal is valid until", ' ', formatLongMonthUSDate(expirationDate), "."]
                }), discountCalloutText && /*#__PURE__*/_jsx(Typography, {
                  "data-testid": CoverPageTestIds.ProposalDiscountCallout(),
                  children: discountCalloutText
                })]
              })]
            }), /*#__PURE__*/_jsx(Divider, {
              margin: 16
            })]
          }), /*#__PURE__*/_jsxs(Column, {
            gap: 8,
            children: [/*#__PURE__*/_jsx(Typography, {
              "data-testid": CoverPageTestIds.RecipientsTitle(),
              variant: "paragraph2",
              skin: "secondary",
              children: "Recipients"
            }), /*#__PURE__*/_jsx(RecipientDetails, {
              className: styles.recipient,
              firstName: relationship.buyer.firstName,
              lastName: relationship.buyer.lastName,
              badge: "required",
              requiredBadgeSkin: "primary"
            }), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map(signatory => /*#__PURE__*/_jsx(RecipientDetails, {
              testid: CoverPageTestIds.Recipient(signatory.id),
              className: styles.recipient,
              firstName: signatory.firstName,
              lastName: signatory.lastName,
              badge: relationshipModel.hasSignatorySigned(relationship, signatory.id) ? 'signed' : 'required',
              requiredBadgeSkin: "primary"
            }, signatory.id)), relationship.reviewers.map(reviewer => /*#__PURE__*/_jsx(RecipientDetails, {
              testid: CoverPageTestIds.Reviewer(reviewer.id),
              className: styles.recipient,
              firstName: reviewer.firstName,
              lastName: reviewer.lastName
            }, reviewer.id))]
          })]
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-testid": CoverPageTestIds.GetStarted(),
            suffixIcon: /*#__PURE__*/_jsx(ArrowRight, {}),
            onClick: onGetStarted,
            className: styles.button,
            children: "Get started"
          })
        })]
      })]
    })
  });
};